export enum InboxRowHandleStatus {
  handledBySelf = 'handledBySelf',
  handledByOtherUser = 'handledByOtherUser',
  handledByDeletedUser = 'handledByDeletedUser',
  notHandled = 'notHandled',
}
